/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  NOTES_CLEAN_REQUEST,
  NOTES_FETCH_REQUEST,
  NOTES_FETCH_REQUEST_SUCCESS,
  NOTES_FETCH_REQUEST_FAILURE
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const noteReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case NOTES_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
              Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
        errors: {},
      });

    case NOTES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTES_CLEAN_REQUEST:
      return Object.assign({}, state, INITIAL_STATE);

    default:
      return state;
  }
};

export default noteReducer;
